import { InputText, Modal } from "src/components";
import { Grid, Button, Typography, Box } from "@material-ui/core";
import NumberFormat from "react-number-format";
import _ from "lodash";
import { Cancel as CancelIcon } from "@material-ui/icons";

import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
dayjs.extend(utc);

function EmpresaClienteView({ open, close, cliente }) {
  function rowMaskCPF(cpf_cnpj) {
    return _.join(
      _.map(cpf_cnpj, (item, index) => (index > 2 && index < 8 ? "*" : item)),
      ""
    );
  }
  return (
    <Modal open={open} width={650}>
      <Grid container sm={12}>
        <Grid item sm={12}>
          <Typography> Dados do cliente </Typography>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={2}>
            <InputText disabled label="ID" value={cliente.cliente_id} />
          </Grid>
          <Grid item sm={10}>
            <InputText disabled label="Nome" value={cliente.nome} />
          </Grid>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={4}>
            <InputText
              disabled
              label="CPF"
              value={rowMaskCPF(cliente.cpf_cnpj)}
            />
          </Grid>
          <Grid item sm={3}>
            <NumberFormat
              disabled
              label="CEP"
              value={cliente.cep}
              format="#####-###"
              customInput={InputText}
            />
          </Grid>
          <Grid item sm={5}>
            <InputText disabled label="Bairro" value={cliente.bairro} />
          </Grid>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={6}>
            <InputText disabled label="Cidade" value={cliente.cidade} />
          </Grid>
          <Grid item sm={2}>
            <InputText disabled label="UF" value={cliente.uf} />
          </Grid>
          <Grid item sm={4}>
            <InputText disabled label="Distancia" value={cliente.Bairro} />
          </Grid>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={4}>
            <NumberFormat
              decimalScale={2}
              fixedDecimalScale={true}
              defaultValue={0}
              prefix={"R$ "}
              thousandSeparator={"."}
              decimalSeparator={","}
              customInput={InputText}
              disabled={true}
              label="Saldo"
              value={cliente.saldo_cashback}
            />
          </Grid>
          <Grid item sm={3}>
            <InputText
              disabled
              label="Operações"
              value={cliente.qtde_cashback}
            />
          </Grid>
          <Grid item sm={5}>
            <InputText
              disabled
              label="Ultima Operação"
              value={dayjs
                .utc(cliente.ultimo_cashback)
                .local()
                .format("DD/MM/YYYY HH:mm:ss")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box
        marginTop="8px"
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button color="secondary" size="small" onClick={() => close()}>
          {<CancelIcon />}&nbsp;Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default EmpresaClienteView;
